import { ReactNode } from "react";
import { Sidebar } from "../../components/Sidebar";

type Props = {
  children: ReactNode;
};

export function Layout({ children }: Props) {
  return (
    <div className="flex h-dvh max-h-dvh flex-col overflow-hidden bg-surface-subtle dark:bg-zinc-950 lg:grid lg:grid-cols-app">
      <Sidebar />
      <main className="relative min-h-0 min-w-0 flex-1 overflow-y-auto overflow-x-hidden overscroll-y-contain px-4 pb-16 pt-4 sm:px-5 lg:col-start-2 lg:px-8 lg:pb-12 lg:pt-10">
        <div className="mx-auto min-w-0 max-w-7xl">{children}</div>
      </main>
    </div>
  );
}
